import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonFunctions } from 'src/app/shared/common-functions';
declare var dataLayer;
@Component({
  selector: 'app-expand-image-dialog',
  templateUrl: './expand-image-dialog.component.html',
  styleUrls: ['./expand-image-dialog.component.scss']
})
export class ExpandImageDialogComponent {
  userType: string;
  userId: any;
  tierType: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { storeImage: any },
    public dialogRef: MatDialogRef<ExpandImageDialogComponent>,
    private commonFunction: CommonFunctions
  ) {
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
  }
  closeDialog() {
    this.dialogRef.close();
  }
  crossBtnGA() {
    dataLayer.push({
      'event': 'cross_click',
      'userID': this.userId,
      'user_type': this.userType,
      'tier': this.tierType
    })
  }
}
